module.exports = __webpack_public_path__ + "img/icon-place.17815505.svg";